import React, { useContext } from 'react'
import { UserContext } from '../Context/UserContext'

export default function Button(props) {
  const {darkTheme} = useContext(UserContext)
  return <div className='flex items-center justify-center'>
    <button {...props} disabled={props.disabled} data-title={props.title} type={props.type} className={`!border px-6 py-2 rounded-lg transition-all text-sm font-medium hover:bg-opacity-80 ${props.className} ${darkTheme? "bg-sky-700 active:bg-slate-300 !border-gray-500" : "!border-gray-200 bg-[#00ADEF] text-white active:bg-slate-100"}`} />
  </div>
}
